// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../public/images/hero-bg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.hero {
  width: 100%;
}

.hero .inner-hero {
  width: 100%;
  min-height: 100vh;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
}

.inner-hero .btn {
  padding: 10px 15px;
  font-size: 14px;
  font-weight: 500;
  color: #fff;
}

.hero-btn:hover{
  filter: brightness(96%);
}

.hero-btn svg{
  height: 20px;
}

.section-1 {
  width: 70%;
}

.card {
  background-color: #fff;
  border-bottom: 3px solid #ffa559;
  padding: 1rem 1rem 0.1rem 1rem;
  margin: 0;
  width: 100%;
}

.card p {
  font-size: 14px;
}

.section-1 img {
  width: 46px;
  padding-bottom: 1rem;
  height: 100%;
}

.section-2 {
  width: 70%;
}

.section-2 button {
  color: #000;
  text-decoration: none;
  font-size: 16px;
  border: none;
  outline: none;
}

.section-2 button:hover {
  text-decoration: underline;
}

@media (max-width: 890px) {
  .hero .inner-hero {
    padding: 0 2.5em;
  }
  .section-1 div {
    flex-wrap: wrap;
  }
}

@media (max-width: 580px) {
  html {
    font-size: 90%;
  }

  .hero .inner-hero {
    padding: 0 1.5em;
  }
  .inner-hero .btn {
    padding: 10px;
    font-size: 13px;
  }

  .section-1,
  .section-2 {
    width: 100%;
    padding: 2em;
  }

  .section-1 div {
    flex-wrap: wrap;
  }
}

@media (max-width: 390px) {
  .inner-hero .btn {
    padding: 10px;
    font-size: 10px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/home.css"],"names":[],"mappings":"AAAA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,yDAAiD;EACjD,2BAA2B;EAC3B,4BAA4B;EAC5B,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,sBAAsB;EACtB,gCAAgC;EAChC,8BAA8B;EAC9B,SAAS;EACT,WAAW;AACb;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,oBAAoB;EACpB,YAAY;AACd;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,qBAAqB;EACrB,eAAe;EACf,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE;IACE,gBAAgB;EAClB;EACA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,cAAc;EAChB;;EAEA;IACE,gBAAgB;EAClB;EACA;IACE,aAAa;IACb,eAAe;EACjB;;EAEA;;IAEE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,aAAa;IACb,eAAe;EACjB;AACF","sourcesContent":[".hero {\n  width: 100%;\n}\n\n.hero .inner-hero {\n  width: 100%;\n  min-height: 100vh;\n  background-image: url(\"../public/images/hero-bg\");\n  background-position: center;\n  background-repeat: no-repeat;\n  background-size: cover;\n}\n\n.inner-hero .btn {\n  padding: 10px 15px;\n  font-size: 14px;\n  font-weight: 500;\n  color: #fff;\n}\n\n.hero-btn:hover{\n  filter: brightness(96%);\n}\n\n.hero-btn svg{\n  height: 20px;\n}\n\n.section-1 {\n  width: 70%;\n}\n\n.card {\n  background-color: #fff;\n  border-bottom: 3px solid #ffa559;\n  padding: 1rem 1rem 0.1rem 1rem;\n  margin: 0;\n  width: 100%;\n}\n\n.card p {\n  font-size: 14px;\n}\n\n.section-1 img {\n  width: 46px;\n  padding-bottom: 1rem;\n  height: 100%;\n}\n\n.section-2 {\n  width: 70%;\n}\n\n.section-2 button {\n  color: #000;\n  text-decoration: none;\n  font-size: 16px;\n  border: none;\n  outline: none;\n}\n\n.section-2 button:hover {\n  text-decoration: underline;\n}\n\n@media (max-width: 890px) {\n  .hero .inner-hero {\n    padding: 0 2.5em;\n  }\n  .section-1 div {\n    flex-wrap: wrap;\n  }\n}\n\n@media (max-width: 580px) {\n  html {\n    font-size: 90%;\n  }\n\n  .hero .inner-hero {\n    padding: 0 1.5em;\n  }\n  .inner-hero .btn {\n    padding: 10px;\n    font-size: 13px;\n  }\n\n  .section-1,\n  .section-2 {\n    width: 100%;\n    padding: 2em;\n  }\n\n  .section-1 div {\n    flex-wrap: wrap;\n  }\n}\n\n@media (max-width: 390px) {\n  .inner-hero .btn {\n    padding: 10px;\n    font-size: 10px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
